import type { FileLinkPayload } from '../schema';

export default function onAssetInvoked(props: FileLinkPayload) {
    window.open(props.url, '_blank');
}
